import gql from 'graphql-tag'

export const CHANGE_PASSWORD = gql`
  mutation changePassword($user: ChangePasswordInput) {
    changePassword(user: $user) {
      success
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/ChangePassword.tsx